import React from "react";

// ContentOptions Component
// Displays a card with a description and a button, which calls a function when clicked.
export default function ContentOptions({
  description,      // Text to display as description
  handleName,       // Callback function to handle button click
  valueButtom,      // Text to display on the button
}) {
  return (
    <>
      {/* Card Wrapper */}
      <div className="card-wrapper text-center selection-card">
        <div className="select-card">
          <div className="card-body col-sm-12 text-label-left">
            
            {/* Description Section */}
            <div className="description">
              {description}  {/* Display the description prop */}
            </div>

            {/* Button Section */}
            <div className="d-flex justify-content-md-center pt-4">
              <input
                type="button"
                value={`${valueButtom}`}        // Button text from valueButtom prop
                className="btn btn_selection_user_type"  // CSS class for styling
                onClick={handleName}            // Trigger handleName function on click
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
